import React from 'react'

const Documents = ({data}:any) => {

    const openFile = (name:any) => {
        if(data.instructor_profile.documents[name].url){
            window.open(data.instructor_profile.documents[name].url, '_blank');
        }
    }

    return (
        <>
        <div className = 'row'>
            <div className = 'col-4'>
                <div className = 'card shadow-sm border'>
                    <div className = 'card-body pointer text-center h3 mb-0 py-6' onClick = {() => openFile('aadhaar')}>
                        Identity Card (Front Side) <small>({(data.instructor_profile.documents && data.instructor_profile.documents.aadhaar && data.instructor_profile.documents.aadhaar.url) ? 'Uploaded' : 'Not Uploaded'})</small>
                    </div>
                </div>
            </div>
            <div className = 'col-4'>
                <div className = 'card shadow-sm border'>
                    <div className = 'card-body pointer text-center h3 mb-0 py-6' onClick = {() => openFile('cancelledCheque')}>
                    Identity Card (Back Side) <small>({(data.instructor_profile.documents && data.instructor_profile.documents.cancelledCheque && data.instructor_profile.documents.cancelledCheque.url) ? 'Uploaded' : 'Not Uploaded'})</small>
                    </div>
                </div>
            </div>
            <div className = 'col-4'>
                <div className = 'card shadow-sm border'>
                    <div className = 'card-body pointer text-center h3 mb-0 py-6' onClick = {() => openFile('education')}>
                        Education Degree <small>({(data.instructor_profile.documents && data.instructor_profile.documents.education && data.instructor_profile.documents.education.url) ? 'Uploaded' : 'Not Uploaded'})</small>
                    </div>
                </div>
            </div>
            <div className = 'col-4'>
                <div className = 'card shadow-sm border'>
                    <div className = 'card-body pointer text-center h3 mb-0 py-6' onClick = {() => openFile('panCard')}>
                        Pan Card <small>({(data.instructor_profile.documents && data.instructor_profile.documents.panCard && data.instructor_profile.documents.panCard.url) ? 'Uploaded' : 'Not Uploaded'})</small>
                    </div>
                </div>
            </div>
            
        </div>

        </>
    )
}

export default Documents

